import React, { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { LoadingSpinner } from '../presentation/spinners'

import IndexContainer from './IndexContainer'
import PersonContainer from './PersonContainer'

const AppRoutes = () => (
  <Suspense fallback={<LoadingSpinner />}>
    <Routes>
      <Route path='/' element={<IndexContainer />} />
      <Route path='/person/:id' element={<PersonContainer />} />
    </Routes>
  </Suspense>
)

export default AppRoutes
